import React from 'react';

import Box from '@mui/material/Box';

import { LAUNCH_ERROR_MESSAGE } from '../../constants';
import { useTicketBootstrap } from '../../hooks';
import TicketForm from '../ticket-form/ticket-form';
import TicketPageError from './ticket-page-error';
import TicketPageLoading from './ticket-page-loading';

const LOADING_MESSAGES = {
  parsing: 'Loading ticket form…',
  redeeming: 'Verifying session…',
  loadingConfig: 'Loading ticket form…'
};

const TicketPage = () => {
  const { status, config, eid } = useTicketBootstrap();

  const renderContent = () => {
    if (status === 'error') {
      return <TicketPageError message={LAUNCH_ERROR_MESSAGE} />;
    }

    if (status === 'ready' && config && eid) {
      return <TicketForm config={config} eid={eid} />;
    }

    return <TicketPageLoading message={LOADING_MESSAGES[status] ?? LOADING_MESSAGES.parsing} />;
  };

  return (
    <Box data-testid="ticket-page" sx={{ minHeight: '100vh' }}>
      {renderContent()}
    </Box>
  );
};

export default TicketPage;
